import {store} from "../store";

export default function (router) {
    router.beforeEach((to, from, next) => {
        // This goes through the matched routes from last to first, finding the closest route with a title.
        // eg. if we have /some/deep/nested/route and /some, /deep, and /nested have titles, nested's will be chosen.
        const nearestWithTitle = to.matched.slice().reverse().find(r => r.meta && r.meta.title);
        
        // If a route with a title was found, set the document (page) title to that value.
        if(nearestWithTitle) document.title = nearestWithTitle.meta.title;

        // if the route is not public
        if (!to.meta.public) {
            // if the user authenticated
            if (store.state.auth.isAuth) {
                // continue to the route
                next();
            } else {
                let redirect = {};
                if (to.name !== 'forecast') {
                    redirect = {redirect: to.path};
                }
                // redirect to login
                next({name: 'login', query: redirect});
            }
        }
        // if the user is authenticated and the route is disabled for authenticated window
        if (store.state.auth.isAuth && to.meta.disableIfLoggedIn) {
            // redirect to home
            next({name: 'home'});
        }
        next();
    })
}